import {
  createCatalogEndpoint,
  createCrudEndpoints,
  createNestedCrudEndpoints,
  createPrintEndpoint,
} from '@/core/utils'
import { TArticle, TPurchaseOrder, TPurchaseOrderDetail, TSupplier } from '.'
import {
  DataWithPagination,
  TBaseCatalogs,
  TBaseHistoryActions,
  TPayment,
} from '@/core/types'
import api from '@/core/config/axios'
import { MaybeRef } from 'vue'
import { AxiosRequestConfig } from 'axios'
import { TMill } from '../mills'

export type TPurchaseOrders = DataWithPagination<TPurchaseOrder>
export type TPayments = DataWithPagination<TPayment>
export const serviceConfig = {
  model: 'purchase-orders',
  version: 'v1',
  details: {
    model: 'details',
    version: 'v1',
  },
  payments: {
    model: 'payments',
    version: 'v1',
  },
  catalogs: {
    suppliers: {
      model: 'suppliers',
      version: 'v1',
    },
    articles: {
      model: 'articles',
      version: 'v1',
    },
    mills: {
      model: 'mills',
      version: 'v1',
    },
    categories: {
      model: undefined,
      version: 'v1',
    },
  },
}

const { suppliers, articles, mills, categories } = serviceConfig.catalogs
const { model: modelDetails, version: versionDetails } = serviceConfig.details
const { model: modelPayments, version: versionPayments } =
  serviceConfig.payments

const moduleServiceHandlers = {
  ...createCrudEndpoints<TPurchaseOrders, TPurchaseOrder>(
    serviceConfig.model,
    serviceConfig.version,
  ),
  loadHistoryActions: async (payload: {
    id?: MaybeRef<number | string>
  }): Promise<Partial<TBaseHistoryActions>[]> =>
    api
      .get(
        `${serviceConfig.version}/${serviceConfig.model}/${payload.id}/history-actions`,
      )
      .then((response) => response.data),

  uploadCertificate: async (
    payload: FormData,
    id?: number,
    config?: AxiosRequestConfig<FormData>,
  ): Promise<TPurchaseOrder> =>
    await api
      .post(
        `${serviceConfig.version}/${serviceConfig.model}/${id}/certificate`,
        payload,
        config,
      )
      .then((response) => response.data),
}
const moduleDetailServiceHandlers = createNestedCrudEndpoints<
  TPurchaseOrderDetail[],
  TPurchaseOrderDetail
>(serviceConfig.model, modelDetails, versionDetails)

const modulePaymentServiceHandlers = createNestedCrudEndpoints<
  TPayments,
  TPayment
>(serviceConfig.model, modelPayments, versionPayments)

const modulePrintHandlers = createPrintEndpoint(
  serviceConfig.model,
  serviceConfig.version,
)

const suppliersCatalog = createCatalogEndpoint<TSupplier[]>(
  suppliers.model,
  suppliers.version,
)

const articlesCatalog = createCatalogEndpoint<TArticle[]>(
  articles.model,
  articles.version,
)

const millsCatalog = createCatalogEndpoint<TMill[]>(mills.model, mills.version)

const categoriesCatalog = createCatalogEndpoint<TBaseCatalogs>(
  categories.model,
  categories.version,
)

const catalogServiceHandlers = {
  suppliersCatalog,
  articlesCatalog,
  millsCatalog,
  categoriesCatalog,
}

export {
  moduleServiceHandlers,
  modulePrintHandlers,
  catalogServiceHandlers,
  moduleDetailServiceHandlers,
  modulePaymentServiceHandlers,
}
